
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useIsMobile } from "@/hooks/use-mobile";

interface ColorPickerProps {
  label: string;
  color: string;
  onChange: (value: string) => void;
}

const ColorPicker = ({ label, color, onChange }: ColorPickerProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="space-y-2">
      <Label htmlFor={label}>{label}</Label>
      <div className={`flex ${isMobile ? 'flex-col space-y-2' : 'space-x-2'}`}>
        <Input
          id={label}
          type="color"
          value={color}
          onChange={(e) => onChange(e.target.value)}
          className={isMobile ? "w-full h-10 p-1" : "w-16 h-10 p-1"}
        />
        <Input
          value={color}
          onChange={(e) => onChange(e.target.value)}
          className="font-mono"
          placeholder="#000000"
        />
      </div>
      <div className="h-10 rounded-md" style={{ backgroundColor: color }}></div>
    </div>
  );
};

export default ColorPicker;
